import React from 'react';

import Register from 'views/Meteorology/Fields/TrackingForecast/Register';
import Maps from 'views/Meteorology/Fields/TrackingForecast/Maps';
import DetailedView from 'views/Meteorology/Fields/TrackingForecast/DetailedView';
import TrackingForecast from 'views/Meteorology/Fields/TrackingForecast';

const trackingForecastRouter = {
  path: 'trackingforecast',
  element: <TrackingForecast />,
  children: [
    { path: '', element: <Register /> },
    { path: 'maps', element: <Maps /> },
    { path: 'detailedview', element: <DetailedView /> },
  ],
};

export default trackingForecastRouter;
